import { Component, OnInit, Input } from "@angular/core";
// ngrx store
import { Store } from "@ngrx/store";
// models
import { AppState } from "../../../models/app-state.interface";
import { take } from "rxjs/operators";
import { updateSbbPublicTransportDiscountStatus } from "app/booking/reducers/booking.actions";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-subsidy",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./subsidy.component.html",
  styleUrls: ["./subsidy.component.scss"],
})
export class SubsidyComponent implements OnInit {
  @Input()
  appCopy;

  @Input()
  appAirportCopy;

  @Input()
  selectedLanguage;

  @Input()
  isSbbSubsidyApplied;

  public airportCode = "";

  constructor(private _appStore: Store<AppState>) {}

  ngOnInit(): void {
    const state = this.getState(this._appStore);
    const productType = state.bookingReducer.bookingDetails.bookingProduct;

    const flightRespone = state.flightReducer.flightDetails.flightResponse;
    this.airportCode = productType === "abc" ? flightRespone.flightStatusDetails[0].departureAirport.airportCode : flightRespone.flightStatusDetails[flightRespone.flightStatusDetails.length - 1].arrivalAirport.airportCode;
    // if (state.d2dReducer.hasSession) {
    // } else {
    //   const flightStatusDetails = state.flightFinderReducer.selectedMultiLegFlight.flightStatusDetails;
    //   this.airportCode = productType === "abc" ? flightStatusDetails[0].departureAirport.airportCode : flightStatusDetails[flightStatusDetails.length - 1].arrivalAirport.airportCode
    // }
  }

  publicTransportSubsidy(val: any) {
    this._appStore.dispatch(updateSbbPublicTransportDiscountStatus({ payload: val.target.checked }));
  }

  getState(store: Store<AppState>) {
    let state: AppState;
    store.pipe((take(1)))
    .subscribe(s => state = s);
    return state;
  }
}
